import { render, staticRenderFns } from "./editAccounts.vue?vue&type=template&id=364055c8&scoped=true"
import script from "./editAccounts.vue?vue&type=script&lang=js"
export * from "./editAccounts.vue?vue&type=script&lang=js"
import style0 from "./editAccounts.vue?vue&type=style&index=0&id=364055c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364055c8",
  null
  
)

export default component.exports